import Vue from "vue";
import store from "@/store";
import i18n from "@/plugins/i18n.js";

const extraTime = {
  install(Vue) {
    Vue.prototype.$appExtraTime = {
      intervals: function () {
        let extraTime = store.getters.storeInfo.configs.maxAllowedExtraTime;

        let newTimes = [];
        let interval = 1;

        for (let minute = 1; minute <= extraTime; ) {
          switch (true) {
            case minute === 1:
              newTimes.push({ value: minute, name: i18n.t("general.minute") });
              break;
            case minute > 1 && minute <= 5:
              newTimes.push({ value: minute, name: i18n.t("general.minutes") });
              if (minute === 5) {
                interval = 5;
              }
              break;

            default:
              newTimes.push({ value: minute, name: i18n.t("general.minutes") });
              interval = 5;
              break;
          }
          minute = minute + interval;
        }
        return newTimes;
      },
      intervalsNotification: function () {
        let maxTime = 60;

        let newTimes = [];
        let interval = 5;

        for (let minute = 5; minute <= maxTime; ) {
          switch (true) {
            case minute >= 5 && minute <= 30:
              newTimes.push({ value: minute, name: i18n.t("general.minutes") });
              if (minute === 30) {
                interval = 15;
              }
              break;

            default:
              newTimes.push({ value: minute, name: i18n.t("general.minutes") });
              break;
          }
          minute = minute + interval;
        }
        return newTimes;
      },
    };
  },
};
Vue.use(extraTime);
